/**
 * RandomDeepJungle Part
 * Randomizes deep jungle terrain appearance at runtime
 */

import { Part } from '../Part';
import { Events } from '../types';
import { Render } from './Render';
import { random } from '@/utils/Random';

/**
 * RandomDeepJungle part
 * On object creation, randomizes the Render part's appearance
 * - 10% bright green, 90% dark green foreground
 * - 50% bright green, 50% dark green detail
 * - Random tile from 4 variants (sw_deepjungle_{1-4}.bmp)
 */
export class RandomDeepJungle extends Part {
  readonly name = 'RandomDeepJungle';

  onEvent(event: string, _data?: unknown): boolean {
    if (event === Events.OBJECT_CREATED) {
      this.setupDeepJungle();
    }
    return true;
  }

  private setupDeepJungle(): void {
    const render = this.parent?.getPart<Render>('Render');
    if (!render) return;

    // 10% bright green, 90% dark green
    const isBright = random.nextInt(10) === 0;
    render.colorString = isBright ? '&G' : '&g';

    // 50% bright/dark detail color
    const isBrightDetail = random.nextBool();
    render.detailColor = isBrightDetail ? 'G' : 'g';

    // Random tile from 4 variants
    const tileNum = random.nextInt(4) + 1;
    render.tile = `Terrain/sw_deepjungle_${tileNum}.bmp`;
  }
}

/**
 * Factory for creating RandomDeepJungle parts
 */
export function createRandomDeepJungle(_params: Record<string, unknown>): RandomDeepJungle {
  return new RandomDeepJungle();
}
